export const DISABLED_USER_MESSAGE = 'Your session has ended because your account is no longer active. If you believe this is an error, please reach out to your organization\'s administrator.';

let redirectToLogin: (() => void) | null = null;

export function registerDisabledUserRedirect(fn: () => void): void {
  redirectToLogin = fn;
}

export function redirectToLoginAfterDisabledUser(): void {
  if (redirectToLogin) {
    redirectToLogin();
  }
}

function getErrorResponseData(error: unknown): unknown {
  const responseData = (error as { response?: { data?: unknown } })?.response?.data;
  if (typeof responseData === 'string') {
    try {
      return JSON.parse(responseData);
    } catch {
      return { message: responseData };
    }
  }
  return responseData;
}

function extractMessage(data: unknown): string | undefined {
  if (!data || typeof data !== 'object') {
    return undefined;
  }

  const record = data as Record<string, unknown>;
  if (typeof record.message === 'string') {
    return record.message;
  }

  if (record.error && typeof record.error === 'object') {
    const nestedError = record.error as Record<string, unknown>;
    if (typeof nestedError.message === 'string') {
      return nestedError.message;
    }
  }

  return undefined;
}

export function isLoginAuthRequest(error: unknown): boolean {
  const config = (error as {
    config?: {
      url?: string;
      auth?: { username?: string; password?: string };
    };
  })?.config;

  if (!config?.url?.includes('/auth')) {
    return false;
  }

  return !!(config.auth?.username || config.auth?.password);
}

export function isDisabledUserError(error: unknown): boolean {
  const message = extractMessage(getErrorResponseData(error));
  if (!message) {
    return false;
  }

  return message === DISABLED_USER_MESSAGE;
}

export function getLoginErrorMessage(error: unknown): string {
  return isDisabledUserError(error)
    ? DISABLED_USER_MESSAGE
    : 'Your username or password do not match';
}
